import Store from "@/store"
export default (val) => {
	return Store.state.account.accountTypes.find(role => role.value === val).label
}